module.exports = __webpack_public_path__ + "img/count_plus.db6943e7.svg";